<template>
  <div class="content">
    <div class="bottom">
      <div class="box">
        <div class="option">
          <div class="optionLeft">
            <div class="top"></div>
            <ul>
              <li>
                <span>
                  服务商：
                </span>
                智联同城网络科技有限公司
              </li>
              <li>
                <span>
                  资质认证：
                </span>
                智联同城网络科技有限公司
              </li>
              <li>
                <span>
                  客服电话：
                </span>
                智联同城网络科技有限公司
              </li>
              <li>
                <span>
                  客服邮箱：
                </span>
                智联同城网络科技有限公司
              </li>
              <li>
                <span>
                  在线客服：
                </span>
                智联同城网络科技有限公司
              </li>
            </ul>
          </div>
          <div class="optionRight">
            <h2>国内短信包</h2>
            <p>
              微盟短信服务，高质量专属通道，各种场景秒达用户，帮您提升转化率。
            </p>
            <div class="list">
              <div class="text">价格</div>
              <div class="listRigth">
                <div class="price">
                  ¥<span>{{
                    choseStatus == "a"
                      ? "100 - 3000"
                      : prices[choseStatus].money
                  }}</span>
                </div>
              </div>
            </div>
            <div class="list">
              <div class="text">套餐优惠</div>
              <div class="listRigth">
                <div class="discount">
                  <div class="money">
                    ¥<span>{{
                      choseStatus == "a"
                        ? "100 - 3000"
                        : prices[choseStatus].money
                    }}</span>
                  </div>
                  <el-button type="danger" size="small">智联价</el-button>
                </div>
              </div>
            </div>
            <div class="list">
              <div class="text">项目</div>
              <div class="listRigth">
                <div class="btn current">国内短信包</div>
              </div>
            </div>
            <div class="list">
              <div class="text">规格</div>
              <div class="listRigth">
                <div class="flex">
                  <div
                    v-for="(item, index) in prices"
                    :key="index"
                    :class="choseStatus == index ? 'btn current' : 'btn'"
                    @click="chose(index)"
                  >
                    {{ item.product }}
                  </div>
                </div>
              </div>
            </div>
            <div class="list">
              <div class="text">发票</div>
              <div class="listRigth">
                <div class="title">
                  第三方服务商未提供该服务发票，如需请咨询第三方服务商
                </div>
              </div>
            </div>
            <div class="list">
              <div class="text"></div>
              <div class="listRigth">
                <el-button type="warning" style="width: 160px" @click="go"
                  >立即订购</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="option"></div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      is_status: 1,
      page: 0,
      total: 0,
      prices: [
        {
          money: "100",
          product: "1000条"
        },
        {
          money: "180",
          product: "2000条"
        },
        {
          money: "250",
          product: "3000条"
        },
        {
          money: "400",
          product: "5000条"
        },
        {
          money: "3000",
          product: "50000条"
        }
      ],
      choseStatus: "a"
    };
  },
  mounted() {
    if (this.$route.query.jude) {
      this.is_status = this.$route.query.jude;
    }
  },
  methods: {
    // 跳转订购
    go() {
      if (this.choseStatus == "a") {
        this.$message.warning("请勾选订购项！！");
        return;
      }
      this.$router.push({
        path: `message-submit?message=${this.choseStatus}`
      });
    },
    chose(index) {
      this.choseStatus = index;
    },
    addSlice(index) {
      this.$router.push({
        path: `adSign?jude=${index}`
      });
    },
    // 分頁
    handleCurrentChange(val) {
      console.log("val", val);
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  background: #fff;
  padding: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    height: 56px;
    font-size: 14px;
    color: #595961;
    line-height: 34px;
    padding: 11px 0;
    display: flex;
    .btn {
      width: 100px;
      height: 36px;
      text-align: center;
      border-radius: 6px;
      margin-right: 5px;
      cursor: pointer;
    }
    .btnCurrent {
      color: #fff;
      background: #2589ff;
    }
  }
  .bottom {
    flex: 1;

    overflow-y: auto;

    .box {
      background: #f2f2f6;
      border-radius: 6px;
      padding: 10px;
    }
    .option {
      width: 100%;
      padding: 10px 20px;
      background-color: #fff !important;
      color: #595961;
      height: 437px;
      margin-bottom: 10px;
      border-radius: 10px;
      display: flex;
      .optionLeft {
        width: 250px;
        .top {
          border: 1px solid #e7e7e7;
          height: 255px;
        }
        ul {
          padding: 5px 15px;
          li {
            padding: 8px 0;
            span {
              display: inline-block;
              width: 60px;
            }
          }
        }
      }
      .optionRight {
        flex: 1;
        font-size: 14px;

        padding-left: 20px;
        h2 {
          height: 30px;
          font-size: 14px;
        }
        p {
          margin-bottom: 15px;
          font-size: 12px;
        }
        .list {
          display: flex;
          align-items: center;
          height: 46px;
          padding: 5px 0;
          .text {
            width: 80px;
          }
          .listRigth {
            .price {
              font-size: 18px;
              color: #000;
              span {
                text-decoration: line-through;
                padding: 0 5px;
              }
            }
            .discount {
              display: flex;
              align-items: center;
              .money {
                font-size: 24px;
                color: #fe545a;
                span {
                  margin: 0 10px;
                }
              }
            }
            .btn {
              border: 1px solid #e7e7e7;
              padding: 6px 10px;
              cursor: pointer;
              color: #666;
              font-size: 12px;
              line-height: 1;
              margin: 5px 5px 5px 0;
              border-radius: 2px;
            }
            .btn:hover {
              border: 1px solid #ff8a00;
            }

            .current {
              border: 1px solid #ff8a00 !important;
              background: url("../../../../../../../public/img/icon_checked.png")
                no-repeat right bottom;
            }
            .flex {
              display: flex;
            }
          }
        }
        .list:last-child {
          margin-top: 15px;
        }
      }
    }
  }
  .el-pagination {
    padding-top: 20px;
    height: 60px;
    border-top: 1px solid #eee;
  }
}
</style>
